module.exports = __webpack_public_path__ + "img/vi_vn.b8c75e82.png";